// Service Worker Registration and Update Management
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(import.meta.env.BASE_URL || '', window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${import.meta.env.BASE_URL.replace(/\/$/, '')}/sw.js`;
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
      } else {
        registerValidSW(swUrl, config);
      }
    });

    // Listen for service worker messages
    navigator.serviceWorker.addEventListener('message', (event) => {
      console.log('[Main] Received SW message:', event.data);
      if (event.data && event.data.type === 'SW_ACTIVATED') {
        console.log('[Main] Service worker activated with version:', event.data.version);
      }
    });

    // Listen for controller changes (when SW updates)
    // Guard against multiple reloads
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      console.log('[Main] Controller changed - new SW is active, reloading');
      window.location.reload();
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[Main] Service worker registered successfully');

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log('[Main] New content is available; automatically updating...');

              // Automatically activate the new service worker
              if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
              }
            } else {
              // At this point, everything has been precached.
              console.log('[Main] Content is cached for offline use.');
            }
          }
        };
      };

      // Check for updates immediately after registration
      setTimeout(() => {
        console.log('[Main] Initial update check...');
        registration.update().catch(err => {
          // Ignore network errors during update check
          console.log('[Main] Initial update check failed (offline?):', err.message);
        });
      }, 1000);

      // Check for updates every 30 minutes in production
      setInterval(() => {
        console.log('[Main] Periodic update check...');
        registration.update().catch(err => {
          // Ignore network errors during periodic check
          console.log('[Main] Periodic update check failed (offline?):', err.message);
        });
      }, 30 * 60 * 1000); // 30 minutes

    })
    .catch((error) => {
      console.error('[Main] Error during service worker registration:', error);
      if (config && config.onError) {
        config.onError(error);
      }
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Check for updates periodically (every 30 minutes)
export function checkForUpdates() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.update().catch(err => {
        console.log('[Main] Manual update check failed:', err.message);
      });
    });
  }
}

// Auto-check for updates every 30 minutes
if ('serviceWorker' in navigator) {
  setInterval(checkForUpdates, 30 * 60 * 1000);
}

// Test function to manually trigger update notification (for development)
export function testUpdateNotification() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      console.log('[Main] Testing update notification');
      showUpdateNotification(registration);
    });
  }
}

// Make test function available globally for console testing
if (typeof window !== 'undefined') {
  window.testUpdateNotification = testUpdateNotification;
}
